import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getAssignableAssigneesForImportRequest } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { GetAssignableAssigneesForImportRequestResponse } from 'services/import-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetAssignableAssigneesForImportRequest = (
  requestId: string,
  options?: Omit<UseQueryOptions<GetAssignableAssigneesForImportRequestResponse, ApiErrorResponse>, 'queryKey'>
) =>
  useQuery<GetAssignableAssigneesForImportRequestResponse, ApiErrorResponse>({
    queryKey: ImportRequestQueryKeys.AssignableAssignees(requestId),
    queryFn: ({ signal }) => getAssignableAssigneesForImportRequest(requestId, { signal }),
    enabled: !!requestId,
    ...options
  })
